// import Colors from '../../../Configs/colors';

const styles = {
  root: {
    '& .tracking-box': {
      background: '#fff',
      border: '1px solid #E9E9FF',
      borderRadius: 8,
      boxShadow: '0px 4px 12px rgba(7, 79, 147, 0.2)',
      padding: 12,
      cursor: 'pointer',
      '& .name': {
        color: '#282828',
      },
      '& .info': {
        fontSize: 12,
      },
      '& .status': {
        background: '#ECF5F8',
        padding: '4px 12px',
        borderRadius: 25,
      },
    },
  },
};

export default styles;
